import React from 'react';

/**
 * Parses HTML string and converts anchor tags to clickable React elements
 * @param htmlString - String containing HTML with anchor tags
 * @returns React element with clickable links
 */
export function parseHtmlWithLinks(htmlString: string): React.ReactNode {
  if (!htmlString) return null;

  // Regular expression to match anchor tags
  const linkRegex = /<a\s+(?:[^>]*?\s+)?href=(["'])(.*?)\1[^>]*>(.*?)<\/a>/gi;
  
  const parts: React.ReactNode[] = [];
  let lastIndex = 0;
  let match;

  while ((match = linkRegex.exec(htmlString)) !== null) {
    // Add text before the link
    if (match.index > lastIndex) {
      parts.push(htmlString.slice(lastIndex, match.index));
    }

    // Add the clickable link
    const href = match[2];
    const linkText = match[3];
    
    parts.push(
      <a
        key={match.index}
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className="text-current underline hover:no-underline"
      >
        {linkText}
      </a>
    );

    lastIndex = match.index + match[0].length;
  }

  // Add remaining text after the last link
  if (lastIndex < htmlString.length) {
    parts.push(htmlString.slice(lastIndex));
  }

  // If no links were found, return the original string
  if (parts.length === 0) {
    return htmlString;
  }

  return <>{parts}</>;
}